export default __webpack_public_path__ + "static/media/marvel-logo.79c232ac.jpg";